import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";

// Full-document boundary: demo never mounts or imports the live provider tree.
const isDemo = /^\/demo(?:\/|$)/.test(window.location.pathname);
const App = lazy(() => isDemo ? import("./demo/DemoApp") : import("@/App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div role="status" data-testid="application-loading" className="p-8 text-slate-600">Loading…</div>}>
      <App />
    </Suspense>
  </React.StrictMode>,
);
